import React, {Component} from 'react';
import $ from 'jquery';
import 'jquery-ui';
import 'jquery-ui/ui/widgets/datepicker';
import  'jquery-ui/themes/base/datepicker.css'
import 'jquery-ui/themes/base/core.css'
import 'jquery-ui/themes/base/theme.css'
import '../../style/formGroupDate.css'
import {DATE_REGURAL_EXPRESSION} from "../../helpers/variables";
import moment from "moment/moment";
import {getHtmlValidDate} from "../../helpers/functions";
import FormGroupPlainText from "../formGroupPlainText";
import calendarIcon from '../../assets/newApplication/calendar.svg';
class FormGroupDateInput extends Component{
    componentDidMount() {
        $('#' + this.props.name + "_datePicker").datepicker(
            {
                dateFormat: "dd/mm/yy",
                yearRange: "1900:2100",
                minDate:this.props.min,
                maxDate:this.props.max,
                changeYear:true,
                changeMonth:true,
                showAnim:'',
                onSelect: (date)=>{
                    this._onChange(this.refs.input.name, date, this.props.Min, this.props.Max)
                }
            }
        );
        $('#' + this.props.name + "_datePicker").attr('placeholder', 'DD/MM/YYYY');
    }

    componentWillReceiveProps(nextProps) {
        $('#' + this.props.name + "_datePicker").datepicker(
            {
                dateFormat: "dd/mm/yy",
                yearRange: "1900:2100",
                minDate: nextProps.min,
                maxDate: nextProps.max,
                changeYear: true,
                changeMonth: true,
                onSelect: (date) => {
                    this._onChange(this.refs.input.name, date, nextProps.Min, nextProps.Max)
                }
            }
        );
    }

    componentWillUnmount() {
        $('#' + this.props.name + "_datePicker").datepicker('destroy');
    }

    _onChange = (name, value, minDate, maxDate) => {
        if(!value){ //if value is  undefined
            if(name.target.value.length >= 8) {
                let split = name.target.value.split('/');
                if(split.length === 3){
                    if(split[2].length === 4){
                        let d = getHtmlValidDate(name.target.value);

                        if (!name.target.value.match(DATE_REGURAL_EXPRESSION)) { //if the date is invalid
                            this.props.handleInputChange(name.target.name, '');
                            return false;
                        }
                        else {
                            if (minDate) { //if minDate exists
                                let t = getHtmlValidDate(minDate);
                                if (moment(d).isBefore(t)) {
                                    this.props.handleInputChange(name.target.name, '');
                                    return false;
                                }
                            }
                            if (maxDate) { //if max date exists
                                let t = getHtmlValidDate(maxDate);
                                if (moment(d).isAfter(t)) {
                                    this.props.handleInputChange(name.target.name, '');
                                    return false;
                                }
                            }
                        }
                    }
                }
            }
        }
        value !== undefined? //when user wants to clear the date the value is undefined
            (this.props.handleInputChange(name, value)):  this.props.handleInputChange(name.target.name, name.target.value);
    };

    render(){
        const {isPlain} = this.props;
        if(isPlain) {
            return (
                <FormGroupPlainText
                    RightWrapper={this.props.rightClassName}
                    rightData={this.props.rightData}
                    LeftWrapper={this.props.leftClassName}
                    InputWrapper={this.props.centerClassName}
                    Label={this.props.label}
                    Text={this.props.value}
                />
            )
        }

        return(
            <div className={'form-group'}>
                <div className={this.props.leftClassName}>
                    <label className={"control-label.text-left formGroup-textInput-label" +
                    (this.props.required?' inputRequired':'')
                    }>
                        {this.props.label}
                    </label>
                </div>
                <div className={this.props.centerClassName}>
                    <input
                        autoComplete={this.props.autoComplete}
                        ref="input"
                        id={this.props.name + "_datePicker"}
                        disabled={this.props.disabled} type="text" required={this.props.required}
                        max={this.props.min} min={this.props.max}
                        className="form-control formGroupDate-input datepicker"
                        placeholder={this.props.Placeholder} name={this.props.name} value={this.props.value}
                        onChange={(name, value, min,max) =>this._onChange(name, value, this.props.min,this.props.max)}/>
                    <div className="formGroupDate-icon-wrapper">
                        <img src={calendarIcon} alt="calendar"/>
                    </div>
                </div>
                <div className={this.props.rightClassName}>{this.props.rightData?this.props.rightData:null}</div>
            </div>
        )
    }
}

export default FormGroupDateInput;